export enum EventExpiresIn {
    'NEVER' = 'NEVER',
    'TODAY' = 'TODAY',
    'TOMORROW' = 'TOMORROW',
    'SEVEN_DAYS' = 'SEVEN_DAYS',
    'CUSTOM' = 'CUSTOM',
}
